module.exports = __webpack_public_path__ + "img/de_1.9de7e750.jpg";